module.exports = __webpack_public_path__ + "media/images/top_ad_banner-f0e717dd01ef3a9360d84255ce736e9b.png";